const isTerminal = (status) =>
  ['CLEAN', 'ERROR', 'INFECTED'].includes(String(status).toUpperCase());

/**
 * REDUCERS
 */

export const fileScanCompleteReducer = (state, action) => {
  const { s3Key, scanStatus, correlationId } = action.payload || {};

  if (!s3Key) {
    return state;
  }

  const currentStatus = state.fileScanByS3Key?.[s3Key];

  // 1. If status is exactly the same, return current state (no re-render)
  if (currentStatus === scanStatus) {
    return state;
  }

  // 2. Terminal Lock: If we are already in a terminal state, don't go back to scanning
  const currentStatusString =
    typeof currentStatus === 'object' ? currentStatus.status : currentStatus;

  if (isTerminal(currentStatusString) && scanStatus === 'scanning') {
    return state;
  }

  const fileScanStatusNow = {
    ...state.fileScanByS3Key,
    [s3Key]: scanStatus,
  };

  const fileScanBySessionNow = {
    ...state.fileScanBySession,
    ...(action.payload.filename && {
      [action.payload.filename]: {
        status: scanStatus,
        correlationId,
        s3Key,
      },
    }),
  };

  // 3. Update the map
  return {
    ...state,
    fileScanByS3Key: fileScanStatusNow,
    fileScanBySession: fileScanBySessionNow,
  };
};

export const fileScanResetReducer = (state, action) => {
  const { s3Key, filename } = action.payload || {};

  if (!s3Key && !filename) {
    return state;
  }

  const { [s3Key]: _, ...nextFileScanByS3Key } = state.fileScanByS3Key || {};
  const { [filename]: __, ...nextFileScanBySession } =
    state.fileScanBySession || {};

  return {
    ...state,
    fileScanByS3Key: nextFileScanByS3Key,
    fileScanBySession: nextFileScanBySession,
  };
};

export const clearAllFileScanStatusReducer = (state) => ({
  ...state,
  fileScanByS3Key: {},
  fileScanBySession: {},
});
